<div class="full-height">
  <div class="login-left">
    <div class="login-left-inner">
      <div class="login-logo">
        <a routerLink="/">
          <img src="/assets/img/new-logo.png" />
        </a>
      </div>

      <ul>
        <li>
          <span>
            <img src="/assets/img/icon-24.png " />
          </span>
          24/7 Online ordering access
        </li>
        <li><span>
            <img src="/assets/img/box-icon.png " />
          </span>Manage orders from multiple suppliers</li>
        <li><span>
            <img src="/assets/img/order-icon.png " />
          </span>Order history, tracking and invoices</li>
        <li><span>
            <img src="/assets/img/folder-icon.png " />
          </span>Live inventory and pricing</li>
      </ul>
    </div>
  </div>

  <div class="login-right">
    <div class="login-right-inner">
      <div class="login-right-scroll overflow-auto">
        <div class="login-box">
          <h3 class="small-30">Reset Password</h3>
          <form class="signup-form" [formGroup]="form" (ngSubmit)="onResetPassword()">
            <p class="label">
              New Password
            </p>
            <input formControlName="password" type="password" class="form-control s-form-field" placeholder="New Password" />
            <span *ngIf="form.get('password').touched || form.get('password').dirty">
              <span class="text-danger" *ngIf="form.get('password').hasError('required')">This field is required.</span>
              <span class="text-danger" *ngIf="form.get('password').hasError('minlength')">Minimum 6 characters are required.</span>
            </span>
            <p class="label">
              Confirm New Password
            </p>
            <input formControlName="password_confirmation" type="password" class="form-control s-form-field" placeholder="Confirm New Password" />
            <span *ngIf="form.get('password_confirmation').touched || form.get('password_confirmation').dirty">
              <span class="text-danger" *ngIf="form.get('password_confirmation').hasError('required')">This field is required.</span>
              <span class="text-danger" *ngIf="form.get('password_confirmation').hasError('minlength')">Minimum 6 characters are required.</span>
              <span class="text-danger"
                *ngIf="form.hasError('passwordMismatch') && (form.get('password_confirmation').touched || form.get('password_confirmation').dirty)">
                Password confirmation must match the password.
              </span>
            </span>
            <button type="submit" class="btn btn-01 mt-4  new-btn" [disabled]="processing">
              <app-preloader *ngIf="processing" [size]="'sm'"></app-preloader>
              <span *ngIf="!processing" class="cursor-pointer">Reset Password</span>
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
